/* eslint-disable no-unneeded-ternary */
import PropTypes from 'prop-types';
import React from 'react';
import { Typography } from '@material-ui/core';

export default function TitleRow({ unit, tirePosition, index }) {
  return (
    <Typography
      variant="h6"
      modifiers="fontWeightBold"
      id={`unitAndWheelPosition${index}`}
    >
      Unit: {unit ? unit : 'unknown'}, Wheel Position:{' '}
      {tirePosition ? tirePosition : 'unknown'}
    </Typography>
  );
}

TitleRow.propTypes = {
  unit: PropTypes.string.isRequired,
  tirePosition: PropTypes.string.isRequired,
  index: PropTypes.string.isRequired,
};
